import api from './core/api';
import { ApiResponse } from './core/AbstractService';
import { Order } from './core/types';

export interface DashboardOrderStats {
  totalOrders: number;
  totalRevenue: number;
  averageOrderValue: number;
  pendingOrders: number;
  processingOrders: number;
  shippedOrders: number;
  deliveredOrders: number;
  cancelledOrders: number;
}

export interface DashboardUserStats {
  total: number;
  active: number;
  newThisMonth: number;
  verified: number;
}

export interface DashboardSummary {
  orderStats: DashboardOrderStats;
  userStats: DashboardUserStats;
  revenueTrend: { labels: string[]; data: number[] };
  recentOrders: Order[];
}

class DashboardService {
  /**
   * Single combined call backing the Dashboard page — replaces what used to be
   * four separate requests (order stats, user stats, revenue analytics, recent orders).
   */
  async getSummary(): Promise<ApiResponse<DashboardSummary>> {
    const response = await api.get<ApiResponse<DashboardSummary>>('/admin/dashboard');
    return response.data;
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
